// extracted by mini-css-extract-plugin
export default {"whyUsContainer":"WhyUs_whyUsContainer__XcQ7f","whyUs":"WhyUs_whyUs__AbFqa","heading":"WhyUs_heading__a23pO","cardContainer":"WhyUs_cardContainer__nVXib"};